export default __webpack_public_path__ + "static/media/2020773.8cb39263.png";